function ContactCard({ icon, textOne, textTwo }) {
  return (
    <div className="flex flex-col justify-center rounded-xl mt-3 mb-4">
      <div className="flex flex-row p-3">
        <div className="justify-center items-center my-auto custom-card p-2">
          {icon}
        </div>
        <div className="flex-col flex-9 text-left px-5">
          <p className="text-white font-[poppins] font-bold">{textOne}</p>
          <p className="font-[poppins] text-gray-300">{textTwo}</p>
        </div>
      </div>
    </div>
  );
}

export default ContactCard;
